import type { FaireProductEntity } from "../../entity_types/product";

export const p_34vjmfpmur: FaireProductEntity = {
  token: "p_34vjmfpmur",
  type: "product",
  name: "SOFTKICKS - Cutie Sneakerinas Contrast Panels",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/25b4887a1033f9d1ec6291b336764b330fe451611dff17d2bd11e71cfa0b6f96.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7636063a2a7481703fb209a29ed526ce0808ed0f08f5323572a3c0874623d11f.jpeg",
    "https://cdn.faire.com/fastly/77dce36e41a68753365e267a930d0eb6db149901628fe7889afe33eb96bc0740.jpeg",
    "https://cdn.faire.com/fastly/7e95adc6cc2f8dded51bb8682549928e593ebd1ca2d6ebd69b42ab02685fb8dc.jpeg",
    "https://cdn.faire.com/fastly/35fdaed439ea564bf25a78cf4ec2ec68fbbab00731ec352583c386d20b650588.jpeg",
    "https://cdn.faire.com/fastly/5d5c002a3583ff8b9f6a193762fabee4e19da8c77d5f4ee7cad75e25fd3771c0.jpeg",
  ],
  priceDollars: 14,
  description:
    "A sporty-meets-ballet flat designed for all-day comfort and effortless style. Featuring a lightweight sneaker-inspired sole, adjustable lace-up detail, and soft gathered collar, this versatile silhouette blends feminine charm with everyday functionality. Available in a range of playful and classic colors, it's the perfect grab-and-go shoe for casual days on the move.\nOOTD\nPair them with relaxed straight-leg jeans and a fitted baby tee for an easy off-duty look, or style them with a tennis skirt and oversized sweatshirt for a sporty-chic vibe. They also look adorable with a flowy mini dress and crew socks for a playful balletcore-inspired outfit.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:11.253Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
